import {FilterValueApiDto} from "../../api/model/rest";
import {NumberFilterType, NumberFilterTypeName} from "../../components/v5/filters/numberFilter/NumberFilter";

export default class NumberFilterModel {
	constructor(public readonly radioButtonId: NumberFilterType) {}

	getDisplayValue() {
		return `${NumberFilterTypeName[this.radioButtonId]}`
	}

	toQueryJson(): FilterValueApiDto[] {
		return null
	}
}